import { render, staticRenderFns } from "./LoadOrdersCards.vue?vue&type=template&id=2d633a50"
import script from "./LoadOrdersCards.vue?vue&type=script&lang=js"
export * from "./LoadOrdersCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports